export default __webpack_public_path__ + "static/sm-b6596da79cb2344618783d63bced1d40.svg";